import React, { FC, ReactNode } from 'react';

import { LoaderTypes } from 'types/app';
import { GetReportsComponent, Report } from 'api';
import { QueryManager } from 'components';

interface IProps {
  children: (data: Report[]) => ReactNode;
  loader?: LoaderTypes;
}

const GetReports: FC<IProps> = ({ children, loader }) => (
  <GetReportsComponent fetchPolicy="network-only">
    {queryResult => (
      <QueryManager loader={loader} {...queryResult}>
        {({ data }) => {
          if (!data || !data.getReports) {
            return null;
          }

          // There is no option to filter these on the server side for now...
          const reports = data.getReports.filter((report: Report) => report.available);

          return children(reports);
        }}
      </QueryManager>
    )}
  </GetReportsComponent>
);

export default GetReports;
